export default __webpack_public_path__ + "static/testimonial-danzel-williams-0ee4af16081089c3e6807b4710caa8d2.png";